import { TApiResponse } from '@/types/response';

import { NsiMpkBusinessStatusDto, TNsiState } from './types';

export function setNsiCountryWithData(state: TNsiState, res: TApiResponse<TNsiState['nsiCountryListWithData']>) {
  const { data = [] } = res;
  state.nsiCountryListWithData = data;
}

export function setNsiBusinessTipsStatusList(state: TNsiState, res: TApiResponse<NsiMpkBusinessStatusDto>) {
  const { data = { items: [] } } = res;
  state.nsiBusinessTipsStatusList = data.items;
}
